export const SHOW_NEW_FEATURE_BOOLEAN_SEARCH =
  'show_new_feature_boolean_search';
export const SHOW_COMPANY_NAME_JOB = 'show_company_name_job';
export const USER_TYPE = 'user_type';
export const NEXT_LOCALE = 'NEXT_LOCALE';
export const SHOW_GUPY_INTEGRATION_ACCESS_MODAL_COMPANY_SEARCH_CANDIDATES_PAGE =
  'show_gupy_integration_access_modal_company_search_candidates_page';
